<template>
  <label
    class="checkbox"
    :for="checkboxID"
    tabindex="0"
    @keyup.space="selectBoxOnClick"
    @keyup.enter="selectBoxOnClick"
  >
    <span class="checkbox__wrapper">
      <input
        :id="checkboxID"
        type="checkbox"
        class="checkbox__input"
        :class="{'checkbox__input--error': !!error}"
        :checked="checked"
        :disabled="disabled"
        :required="required"
        :value="modelValue"
        @change="updateValue"
        ref="inputRef"
        :aria-invalid="!!error"
        :aria-errormessage="!!error ? `${checkboxID}-error` : null"
      >
      <span class="checkbox__box"
            role="checkbox"
            :aria-label="$t('global.checkbox.aria.label', [name])"
      />
      <span
        class="checkbox__label"
        :class="{
          'checkbox__label--disabled': disabled,
          'input__label--required': required
        }"
        v-html="label"
      />
    </span>
    <span
        :id="`${checkboxID}-error`"
      class="input__error | input-error"
      v-if="!!error"
      v-html="error"
    />
  </label>
</template>

<script>
  import randomId from '../../utilities/js/randomId/randomId';

  export default {
    props: {
      checked: Boolean,
      required: {
        type: Boolean,
        required: false,
        default: false
      },
      modelValue: {
        type: Boolean,
        required: false,
        default: false
      },
      name: {
        type: String,
        default() {
          return '';
        }
      },
      label: String,
      disabled: {
        type: Boolean,
        default: false,
      },
      error: {
        type: String,
        required: false,
        default: null
      }
    },
    data() {
      return {
        checkboxID: this.id ? this.id : randomId(this.checked)
      }
    },
    emits: ['update:modelValue'],
    methods: {
      selectBoxOnClick() {
        this.$refs.inputRef.click();
      },
      updateValue(e) {
        this.$emit('update:modelValue', e.target.checked);
      }
    },
  };

</script>
